import { NavigationLink } from '@hellodarwin/core/lib/features/entities';
import { AccessLevel } from '@hellodarwin/core/lib/features/entities/pages-entities';
import Accueil from '@hellodarwin/icons/dist/icons/Accueil';
import ArtificialIntelligence from '@hellodarwin/icons/dist/icons/ArtificialIntelligence';
import DeploymentUnit from '@hellodarwin/icons/dist/icons/DeploymentUnit';
import File from '@hellodarwin/icons/dist/icons/File';
import Grants from '@hellodarwin/icons/dist/icons/Grants';
import Help from '@hellodarwin/icons/dist/icons/Help';
import Language from '@hellodarwin/icons/dist/icons/Language';
import Notifications from '@hellodarwin/icons/dist/icons/Notifications';
import ProjectIcon from '@hellodarwin/icons/dist/icons/ProjectIcon';
import Search from '@hellodarwin/icons/dist/icons/Search';

interface NavigationLabels {
  dashboard: NavigationLink['label'];
  planning: NavigationLink['label'];
  documents: NavigationLink['label'];
  fundingExplorer: NavigationLink['label'];
  assistant: NavigationLink['label'];
  applications: NavigationLink['label'];
  fundingIntelligence: NavigationLink['label'];
  alerts: NavigationLink['label'];
  aiIntegration: NavigationLink['label'];
  tools: NavigationLink['label'];
  support: NavigationLink['label'];
  resources: NavigationLink['label'];
  faq: NavigationLink['label'];
  contactUs: NavigationLink['label'];
}

interface BuildNavigationLinksOptions {
  accessLevel: AccessLevel;
  applicationNotifications: number;
  documentRequests: number;
  isTablet: boolean;
  labels: NavigationLabels;
}

export const buildNavigationLinks = ({
  accessLevel,
  applicationNotifications,
  documentRequests,
  isTablet,
  labels,
}: BuildNavigationLinksOptions): NavigationLink[] => {
  const fundingExplorerLink: NavigationLink = {
    pathname: '/funding-explorer',
    label: labels.fundingExplorer,
    Icon: Search,
  };
  const assistantLink: NavigationLink = {
    pathname: '/assistant',
    label: labels.assistant,
    Icon: ArtificialIntelligence,
  };
  const fundingIntelligenceLink: NavigationLink = {
    pathname: '/funding-intelligence',
    label: labels.fundingIntelligence,
    Icon: Language,
  };
  const aiIntegrationLink: NavigationLink = {
    pathname: '/ai-integration',
    label: labels.aiIntegration,
    Icon: DeploymentUnit,
  };
  const applicationsLink: NavigationLink = {
    pathname: '/applications',
    label: labels.applications,
    notifs: applicationNotifications,
    Icon: Grants,
  };

  return [
    ...(!isTablet
      ? [
          {
            pathname: '/dashboard',
            label: labels.dashboard,
            Icon: Accueil,
          },
        ]
      : []),
    ...(accessLevel === 'custom'
      ? [
          {
            pathname: '/game-plan',
            label: labels.planning,
            Icon: ProjectIcon,
          },
          {
            pathname: '/documents',
            label: labels.documents,
            notifs: documentRequests,
            Icon: File,
          },
          applicationsLink,
          {
            pathname: '/assistant',
            label: labels.tools,
            Icon: DeploymentUnit,
            subLinks: [
              {
                pathname: assistantLink.pathname,
                label: assistantLink.label,
              },
              {
                pathname: fundingExplorerLink.pathname,
                label: fundingExplorerLink.label,
              },
              {
                pathname: fundingIntelligenceLink.pathname,
                label: fundingIntelligenceLink.label,
              },
              {
                pathname: aiIntegrationLink.pathname,
                label: aiIntegrationLink.label,
              },
            ],
          },
        ]
      : [fundingExplorerLink, assistantLink]),
    ...(accessLevel === 'custom'
      ? []
      : [applicationsLink, fundingIntelligenceLink]),
    ...(accessLevel !== 'custom'
      ? [
          {
            pathname: '/alerts',
            label: labels.alerts,
            Icon: Notifications,
          },
          aiIntegrationLink,
        ]
      : []),
    {
      pathname: '/faq',
      label: labels.support,
      Icon: Help,
      subLinks: [
        {
          pathname: '/resources',
          label: labels.resources,
        },
        {
          pathname: '/faq',
          label: labels.faq,
        },
        {
          pathname: '/contact-us',
          label: labels.contactUs,
        },
      ],
    },
  ];
};
